module.exports = __webpack_public_path__ + "media/images/athletes/2117-71faafdfbd7e2cd999989441dab924ba.png";